import axios from "axios";
import { Base_Url, App_Language, App_Version } from "./constants/ApiConstant";
import { getToken,showMessage,logout } from "./utils";
let   activeRequests: number = 0;
// instance 
const axiosInstance = axios.create({
  baseURL: Base_Url,
});


axiosInstance.interceptors.request.use(function (config:any) {

  if (activeRequests === 0) {
    document.body.classList.add('loader-show');
}

 activeRequests++;
  if (getToken()) {
     config.headers.Authorization =  `Bearer ${getToken()}`
  }
  return config
}, function (error) {
  hideLoader()
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  response => {
  
         if(response.data && response.data.status==500){
           if(response.data.message)
          showMessage(response.data.message)
          return Promise.reject(response.data)
         }
         hideLoader()
    return response.data
  },
  error => {

     if(error.response && error.response.data){
      if(error.response.data.statusCode==401){
       logout()
      }
      if(error.response.data.message)
      showMessage(error.response.data.message)
     }else 
      if(error?.message){
        showMessage(error.message)
      }
   hideLoader()
    return Promise.reject(error)
       
  }
)


const hideLoader=()=>{
  activeRequests--;
  if (activeRequests === 0) {
  document.body.classList.remove('loader-show');
   }
}


export const getRequest = (url:any, payload:any) => {
  let config = {
    params: {
      ...payload
    },
  }
  return axiosInstance.get(url, config)
}

export const postRequest = (url:any, payload:any, params?:any) => {


  return axiosInstance.post(url, payload, {
    params: params
  })
}

export const putRequest = (url:any, payload:any,params?:any) => {    
  return axiosInstance.put(url, payload, {
    params:params
  })
}

export const putRequest1 = (url:any, payload:any,params?:any) => { 
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  // url.append(config)  
  return axiosInstance.put(url, payload, {
    params:params
  })
}



export const deleteRequest = (url:any, payload:any) => {

    let query="?"
Object.keys(payload).forEach((k,j)=>{
  if(j>0){
    
    query=query+"&"+k+"="+payload[k]  
  } else {query=query+k+"="+payload[k]}
})
if(query != "?")
{
  return axiosInstance.delete(url + query)
} else {
  return axiosInstance.delete(url + query+ 'id='+payload)
}
  //return axiosInstance.delete(url + query+ 'id='+payload);
}

